<template>
  <div class="modal">
    <div class="modal__bg" @click="$emit('close')"></div>
    <div class="modal__body" ref="modalBody">
      <div
        v-if="
          modalParams.name === 'add-member' ||
            modalParams.name === 'edit-member' ||
            modalParams.name === 'change-password'
        "
      >
        <h4 class="modal__header">
          <span v-if="modalParams.name === 'add-member'">Add New Member</span>
          <span v-if="modalParams.name === 'edit-member'"
            >Edit Member Details</span
          >
          <span v-if="modalParams.name === 'change-password'"
            >Change Password</span
          >
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <AddNewMember
          :singleRecord="modalParams.singleRecord"
          @close="$emit('close')"
          v-if="modalParams.name != 'change-password'"
        />
        <ChangePassword
          :singleRecord="modalParams.singleRecord"
          @close="$emit('close')"
          v-if="modalParams.name == 'change-password'"
        />
      </div>
      <div
        v-if="
          modalParams.name === 'add-company' ||
            modalParams.name === 'edit-company'
        "
      >
        <h4 class="modal__header">
          <span v-if="modalParams.name === 'add-company'">Add New Company</span>
          <span v-if="modalParams.name === 'edit-company'">Edit Company</span>
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <AddNewCompany
          :singleRecord="modalParams.singleRecord"
          @close="$emit('close')"
          @toggleScroll="handleToggleScroll"
        />
      </div>
      <div
        v-if="
          modalParams.name === 'add-event' || modalParams.name === 'edit-event'
        "
      >
        <h4 class="modal__header mb-30">
          <span v-if="modalParams.name === 'add-event'">Add New Event</span>
          <span v-if="modalParams.name === 'edit-event'">Edit Event</span>
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <AddNewEvent
          @toggleScroll="handleToggleScroll"
          :singleRecord="modalParams.singleRecord"
          @close="$emit('close')"
        />
      </div>
      <div v-if="modalParams.name === 'report-bug'">
        <h4 class="modal__header">
          Report an Issue
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <ReportABug @close="$emit('close')" />
      </div>
      <div v-if="modalParams.name === 'add-company-member'">
        <h4 class="modal__header">
          Add Members
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <AddCompanyMembers
          :singleRecord="modalParams.singleRecord"
          @close="$emit('close')"
        />
      </div>
      <div v-if="modalParams.name === 'add-event-participant'">
        <h4 class="modal__header">
          Add Participants
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <AddEventParticipant
          :singleEventId="modalParams.id"
          @close="$emit('close')"
        />
      </div>
      <div v-if="modalParams.name === 'book-a-member'">
        <h4 class="modal__header">
          Book existing member
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <BookAMember />
      </div>
      <div v-if="modalParams.name === 'view-member-profile'">
        <h4 class="modal__header">
          Profile overview
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <ViewMemberProfile :modalParams="modalParams" @close="$emit('close')" />
      </div>
      <ProfileEdit v-if="modalParams.name === 'edit'" @close="$emit('close')" />
    </div>
  </div>
</template>

<script>
import {
  AddNewMember,
  AddEventParticipant,
  AddNewCompany,
  ChangePassword,
  AddNewEvent,
  ReportABug,
  AddCompanyMembers,
  BookAMember,
  ViewMemberProfile
} from "@/modules/concierge/elements/forms";

import ProfileEdit from "@/modules/admin/elements/ProfileEdit";

export default {
  name: "Modal",
  components: {
    AddNewMember,
    AddNewCompany,
    ChangePassword,
    AddNewEvent,
    AddCompanyMembers,
    ReportABug,
    AddEventParticipant,
    BookAMember,
    ViewMemberProfile,
    ProfileEdit
  },
  props: {
    backTo: String,
    isOpened: {
      type: Boolean,
      default: false
    },
    modalParams: {
      type: Object,
      default: () => {}
    }
  },
  destroyed() {
    document.body.style.overflow = "initial";
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    close() {},
    handleToggleScroll(params) {
      const { scroll } = params;
      this.$refs.modalBody.style.overflow = scroll ? "auto" : "hidden";
    }
  }
};
</script>

<style lang="scss" scoped>
.h-0 {
  height: 0;
}
.modal {
  display: block;
  min-height: 100vh;
  left: 0;
  width: 100%;
  .row {
    width: inherit;
  }
  /deep/ &__bg {
    background-color: black;
    height: 100%;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  /deep/ &__body {
    animation: fade-in-up 0.25s ease-out forwards;
    background-color: white;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    font-family: "Gotham";
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 650px;
    z-index: 1;
    .form-material {
      padding-top: 10px;
    }
    a {
      font-family: "Gotham";
      font-size: $font-size-sm;
    }
    button {
      padding: 8px 14px;
      font-size: $font-size-sm;
    }
  }
  /deep/ &__header {
    color: $gray-900;
    font-size: $font-size-base;
    margin-bottom: 40px;
    position: relative;
    img {
      cursor: pointer;
      top: 0;
      position: absolute;
      right: 0;
    }
    span {
      font-family: "Gotham";
    }
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>
